/**
 * @generated SignedSource<<2ad7d5669ab55369e9a468eedc0286a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CityWalkTimelineWaypoint_waypoint",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "indexLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFilled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CityWalk",
      "kind": "LinkedField",
      "name": "cityWalk",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CityWalkWaypoint",
  "abstractKey": null
};

node.hash = "d7ffd894897350663cf31154456ef239";

module.exports = node;
